import type { EnrollmentChoices } from 'bundles/enroll-common/components/xdp/withEnrollment';
import type { ModalType } from 'bundles/enroll-modal/hooks/useEnrollmentModalState';
import { MODAL_TYPES } from 'bundles/enroll-modal/hooks/useEnrollmentModalState';
import paymentsExperiments from 'bundles/epic/clients/__generated__/payments';
import { useGenerateEnrollModalImpressionForHighIncomeCountryPricingTest } from 'bundles/payments-common/utils/highIncomeCountryPricingTestUtils';

export type UseEnrollModalExperimentsProps = {
  activeModal: ModalType | null;
  enrollmentAvailableChoices?: EnrollmentChoices;
  courseId: string;
  s12nId?: string;
};

export type UseEnrollModalExperimentsResult = {
  shouldPreloadEnrollModal: boolean;
};

/**
 * Centralizes the enroll modal's EPIC experiment impressions so the orchestrator
 * stays out of the pricing-test plumbing.
 */
export const useEnrollModalExperiments = ({
  activeModal,
  enrollmentAvailableChoices,
  courseId,
  s12nId,
}: UseEnrollModalExperimentsProps): UseEnrollModalExperimentsResult => {
  useGenerateEnrollModalImpressionForHighIncomeCountryPricingTest({
    enrollmentAvailableChoices,
    courseId,
    s12nId,
    skip: activeModal !== MODAL_TYPES.ENROLL, // only generate impression upon opening the enroll modal
  });

  return {
    shouldPreloadEnrollModal: paymentsExperiments.get('preloadEnrollModalEnabled'),
  };
};

export default useEnrollModalExperiments;
